/** The slice of a Zod schema this check needs (frontend-app does not depend on zod directly). */
interface Checkable {
	safeParse: (value: unknown) => { success: true } | { success: false; error: { issues: { path: PropertyKey[] }[] } }
}

/**
 * Check a snake_case wire body with its shared `@today/models` schema (TO-420
 * design D2) and map each failing top-level key to `validation.<field>`, where
 * `field` is the form's camelCase name. An issue without a path lands on
 * `fallback`. `{}` means the body may be sent.
 */
export const schemaErrors = (
	schema: Checkable,
	body: Record<string, unknown>,
	fallback: string,
): Record<string, string> => {
	const result = schema.safeParse(body)
	if (result.success) return {}
	const errors: Record<string, string> = {}
	for (const issue of result.error.issues) {
		const key = issue.path[0]
		const field = typeof key === 'string' ? key.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase()) : fallback
		errors[field] ??= `validation.${field}`
	}
	return errors
}
